import { Link, type LinkProps } from '#app/components/Link/index.js';
import { useExactMatch } from '#app/hooks/useExactMatch.js';
import {
  LockedTabContent,
  Tab,
  TabIconContainer,
  TabLink,
  TabLinkContent,
  TabText,
} from './RoutingTabs.styles.js';
import { type IconSvgProps } from '@contra/icons/icons';
import { type ComponentType, forwardRef, type Ref } from 'react';

type RoutingTabProps = LinkProps & {
  readonly as?: 'li' | 'span';
  readonly icon?: ComponentType<IconSvgProps>;
  readonly isDisabled?: boolean;
  readonly match?: () => boolean;
};

export const RoutingTab = forwardRef(
  (
    {
      children,
      icon: Icon,
      isDisabled = false,
      match,
      to,
      ...linkProps
    }: RoutingTabProps,
    ref: Ref<HTMLLIElement>,
  ) => {
    const toIsExactMatch = useExactMatch(to);

    const isActiveTab = match ? match() : toIsExactMatch;

    if (isDisabled) {
      return (
        <Tab
          isActiveTab={isActiveTab}
          ref={ref}
        >
          <LockedTabContent>
            <TabLinkContent isActiveTab={isActiveTab}>
              {Icon ? (
                <TabIconContainer>
                  <Icon size={16} />
                </TabIconContainer>
              ) : null}
              <TabText>{children}</TabText>
            </TabLinkContent>
          </LockedTabContent>
        </Tab>
      );
    }

    return (
      <Tab
        isActiveTab={isActiveTab}
        ref={ref}
      >
        <TabLink
          {...linkProps}
          as={Link}
          to={to}
        >
          <TabLinkContent isActiveTab={isActiveTab}>
            {Icon ? (
              <TabIconContainer>
                <Icon size={16} />
              </TabIconContainer>
            ) : null}
            <TabText>{children}</TabText>
          </TabLinkContent>
        </TabLink>
      </Tab>
    );
  },
);
